import type { FC } from 'react'
import React, { useContext } from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import { Icon } from '@frontend/pole-ui/lib/components/Icon'
import { ArrowLeft2Icon } from '@frontend/pole-ui/lib/components/Icon/svg/ArrowLeft2Icon'
import { ArrowRight2Icon } from '@frontend/pole-ui/lib/components/Icon/svg/ArrowRight2Icon'
import { pushFormattedGtmEvent } from '@/logic/metrika/helpers'
import { FaqContext } from '../../constants'
import { getTransliteratedGtmEvents } from '../../gtmHelpers'
import { getArticleUrl } from '../../helpers'
import type { IFaqParams } from '../../types'
import type { INearestArticleProps } from './interfaces'
import './styles.scss'

const NearestArticle: FC<INearestArticleProps> = ({ article, iconPosition }) => {
  const { specializationId, categoryId } = useContext(FaqContext).params as Required<IFaqParams>
  if (!article) return <div className="faq-nearest-article faq-nearest-article_empty" />

  const { id: questionId, question } = article

  const handleClick = () => {
    pushFormattedGtmEvent(
      getTransliteratedGtmEvents({
        blockName: 'blockSearch',
        eventLabel: `${iconPosition === 'left' ? 'buttonBack' : 'buttonNext'}`,
      }),
    )
  }

  return (
    <CommonLink
      className={`text_small-from-sm faq-nearest-article faq-nearest-article_${iconPosition}`}
      url={getArticleUrl({ categoryId, specializationId, questionId })}
      onClick={handleClick}
    >
      <span className={`faq-nearest-article__icon faq-nearest-article__icon_${iconPosition}`}>
        <Icon component={iconPosition === 'left' ? <ArrowLeft2Icon /> : <ArrowRight2Icon />} />
      </span>
      <span className={`faq-nearest-article__text faq-nearest-article__text_${iconPosition}`}>{question}</span>
    </CommonLink>
  )
}

export default NearestArticle
